<template>

  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
         <b-col lg="12">
           <b-card>
             <template v-slot:header>
                 <strong>Vehicle</strong>
                 <div class="pull-right">
                   <button class="btn btn-warning" @click="$router.go(-1)"><i title="Back" class="fa fa-arrow-left fa-lg text-white"></i> <strong class="text-white">Return to Inventory</strong></button>
                   <button class="btn btn-info" v-if="(!multipleVehicleMatch || multipleVehicleMatch.length === 0) && vehicle" @click="saveVehicle"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
                 </div>
             </template>
             <b-row>
               <b-col lg="6" v-if="multipleVehicleMatch && multipleVehicleMatch.length > 0">
                 <b-card>
                   <template v-slot:header>
                     <b-alert variant="warning" class="mb-0" show><strong>Multiple vehicles match for this VIN, select a vehicle to proceed.</strong></b-alert>
                   </template>
                   <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                     <tbody>
                       <tr v-for="(vm, i) in multipleVehicleMatch">
                         <td style="width:85px;">
                           <button class="btn btn-primary text-white" @click="selectMultiVehicle(vm)">
                             <i class="fa fa-car" title="Select this vehicle"></i> Select
                           </button>
                         </td>
                         <td>
                           {{vm.description}}
                         </td>
                       </tr>
                     </tbody>
                   </table>
                 </b-card>
               </b-col>
             </b-row>

             <b-row v-if="(!multipleVehicleMatch || multipleVehicleMatch.length === 0) && vehicle && vehicle.FullVehicleDescription && vehicle.FullVehicleDescription.length > 0">
               <b-col>
                 <h4>{{vehicle.FullVehicleDescription}}</h4>
               </b-col>
             </b-row>
           </b-card>
      </b-col>
        </b-row>
        <b-row v-if="(!multipleVehicleMatch || multipleVehicleMatch.length === 0) && vehicle">
          <b-col lg="6">
            <b-card v-if="vehicle" class="pb-3">
              <template v-slot:header>
                <strong>Vehicle Details</strong>
              </template>
               <b-row class="my-1">
                <b-col lg="3">
                  <label>VIN</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input type="text" v-model="vehicle.VIN" :maxlength="17" v-validate="{required: true}"
                                v-bind:class="{'is-invalid': validateErrors.has('VIN') }" name="VIN"></b-form-input>
                  <em class="error invalid-feedback">{{ validateErrors.first('VIN') }}</em>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Stock #</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input type="text" v-model="vehicle.StockNumber" v-validate="{required: true}"
                                v-bind:class="{'is-invalid': validateErrors.has('Stock') }" name="Stock"
                                :maxlength="20"></b-form-input>
                  <em class="error invalid-feedback">{{ validateErrors.first('Stock') }}</em>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Exterior Color</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input type="text" v-model="vehicle.ExteriorColor" :maxlength="50"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Interior Color</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input type="text" v-model="vehicle.InteriorColor" :maxlength="50"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Options/Packages</label>
                </b-col>
                <b-col lg="6">
                  <b-form-textarea type="text" v-model="vehicle.Options" :rows="3" :maxlength="120"></b-form-textarea>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Lot Age (days)</label>
                </b-col>
                <b-col lg="3">
                  <b-form-input type="text" v-model="vehicle.LotAge" name="Lotage" :maxlength="10" v-validate="{numeric: true, min_value:0}"
                                v-bind:class="{'is-invalid': validateErrors.has('Lotage') }"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3" class="mt-2">
                  Mileage
                </b-col>
                <b-col lg="3">
                  <b-form-input type="text" v-model="vehicle.DemoMiles" name="Mileage" v-validate="{numeric: true}"
                                v-bind:class="{'is-invalid': validateErrors.has('Mileage') }"></b-form-input>
                </b-col>
                <b-col lg="4" class="mt-2" v-if="!vehicle.IsNew">
                  <b-form-checkbox v-model="vehicle.CertifiedPreOwned">Certified Pre-owned</b-form-checkbox>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col><h4>MSRP</h4></b-col>
              </b-row>
              <b-row class="my-1" >
                <b-col lg="2">
                  Base Value
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.BaseValueMSRP" name="BaseValueMSRP" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('BaseValueMSRP') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Total
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.TotalMSRP" name="TotalMSRP" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('TotalMSRP') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Discounts
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.MSRPDiscounts" name="MSRPDiscounts" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('MSRPDiscounts') }"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col><h4>Cost</h4></b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="2">
                  Before Adds
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.DealerCostBeforeAdds" name="DealerCostBeforeAdds" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('DealerCostBeforeAdds') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Added Equipments
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.OptionsAndTreatmentCost" name="OptionsAndTreatmentCost" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('OptionsAndTreatmentCost') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Total Dealer Cost
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.TotalDealerCost" name="TotalDealerCost" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('TotalDealerCost') }"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col><h4>Prices</h4></b-col>
              </b-row>

              <b-row class="my-1">
                <b-col lg="2">
                  Sticker
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.Price" name="Price" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('Price') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Preferred
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.PreferredPrice" name="PreferredPrice" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('PreferredPrice') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  GMS
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" style="width:100px" class="money" v-model="vehicle.GMSPrice" name="GMSPrice" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('GMSPrice') }"></b-form-input>
                </b-col>
              </b-row>
              <slot v-if="vehicle.AddsDeducts && vehicle.AddsDeducts.NewCar && vehicle.AddsDeducts.NewCar.VehicleDeductions">
                <b-row class="my-1">
                  <b-col><h4>Deductions</h4></b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <slot v-for="item in vehicle.AddsDeducts.NewCar.VehicleDeductions">
                      <b-form-checkbox v-model="item.Added">{{item.Name}}</b-form-checkbox>
                    </slot>
                  </b-col>
                </b-row>
              </slot>

            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card>
              <template v-slot:header>
                  <strong>Vehicle Equipment</strong>
                </template>
                <b-table :items="predefinedEquipment" :fields="predefinedEquipmentFields" hover striped bordered small caption-top responsive stacked="md"
                         :filter="filterPredefined" @filtered="onPredefinedFiltered"
                         :current-page="currentPage" :per-page="perPage" show-empty>
                  <template v-slot:table-caption>
                    <b-row>
                      <b-col md="5">
                        <b-form-group>
                          <b-input-group>
                            <b-form-input v-model="filterPredefined" placeholder="Type to Search" />
                            <b-input-group-append>
                              <b-btn :disabled="!filterPredefined" @click="filterPredefined = ''">Clear</b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </template>

                  <template v-slot:cell(Factory)="data">
                    <b-form-checkbox v-model="data.item.Factory"></b-form-checkbox>
                  </template>
                  <template v-slot:cell(Added)="data">
                    <b-form-checkbox v-model="data.item.Added"></b-form-checkbox>
                  </template>
                  <template v-slot:cell(Cost)="data">
                    <b-form-input name="pCost" v-model="data.item.Cost"
                                  v-bind:class="{'is-invalid': validateErrors.has('pCost') }" v-validate="{required: true, decimal: 2}" />
                  </template>
                  <template v-slot:cell(Price)="data">
                    <b-form-input v-model="data.item.Price" name="pPrice" v-validate="{decimal: 2}"
                                  v-bind:class="{'is-invalid': validateErrors.has('pPrice') }" />
                  </template>

                </b-table>
                <b-row>
                  <b-col>
                    <nav>
                      <b-pagination :total-rows="predefinedEquipment.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
                    </nav>
                  </b-col>
                  <b-col><div class="pull-right my-2">Showing {{ totalRows}} / {{ predefinedEquipment.length }} records</div></b-col>
                </b-row>
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card>
              <template v-slot:header>
                <strong>Dealer Defined Equipment</strong>
              </template>

              <b-table :items="dealerDefinedEquipment" :fields="dealerDefinedEquipmentFields" hover striped bordered small caption-top responsive stacked="md"
                       :filter="filter" @filtered="onFiltered" show-empty :current-page="currentPage2" :per-page="perPage2">
                <template v-slot:table-caption>
                  <b-row>
                    <b-col md="5">
                      <b-form-group>
                        <b-input-group>
                          <b-form-input v-model="filter" placeholder="Type to Search" />
                          <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <!--<b-col>
                      <b-button class="pull-right" variant="outline-success" @click="addDealerEquipment" title="Add">
                        <i class="fa fa-plus-square"></i> <strong>Add</strong>
                      </b-button>
                    </b-col>-->

                  </b-row>
                </template>
                <!--<template v-slot:cell(NewUsedType)="data">
                  <slot v-if="!data.item.editEquipment">{{data.item.Type}}</slot>
                  <b-form-select v-if="data.item.editEquipment" v-model="data.item.NewUsedType" :options="typeoptions" />
                </template>-->
                <template v-slot:cell(IsSelected)="data">
                  <b-form-checkbox v-model="data.item.IsSelected"></b-form-checkbox>
                </template>
                <template v-slot:cell(IsSuggested)="data">
                  <b-form-checkbox v-model="data.item.IsSuggested"></b-form-checkbox>
                </template>
                <template v-slot:cell(Cost)="data">
                  <b-form-input v-model="data.item.Cost" name="dCost"
                                v-bind:class="{'is-invalid': validateErrors.has('dCost') }" v-validate="{decimal: 2}" />
                </template>
                <template v-slot:cell(Price)="data">
                  <b-form-input v-model="data.item.Price" name="dPrice" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('dPrice') }" />
                </template>

                <template v-slot:cell(Tax)="data">
                  <b-form-checkbox v-model="data.item.Tax" @change="taxExemptChanged(data.item)"></b-form-checkbox>
                </template>

              </b-table>
              <b-row>
                <b-col>
                  <nav>
                    <b-pagination :total-rows="totalRows2" :per-page="perPage2" v-model="currentPage2" prev-text="Prev" next-text="Next" />
                  </nav>
                </b-col>
                <b-col><div class="pull-right my-2">Showing {{ totalRows2}} / {{ dealerDefinedEquipment.length }} records</div></b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'

export default {
  components: {
    loading
  },
  created () {
    let self = this
    self.boolLoading = true
    axios.post('/api/inventory/loadvehicle?vid=' + this.$route.params.vehicleId)
      .then(response => {
        if (response.data.err.length > 0) {
          self.errMsg = 'There was an error getting data : ' + response.data.err
          self.showDismissibleAlert = true
          self.dismissibleType = 'danger'
        }
        else {
          self.vehicle = response.data.vehicle
          self.predefinedEquipment = response.data.vehicle.AddsDeducts.DealerInstalled
          self.loadDealerData(response.data.vehicle.AddsDeducts.DealerDefEquipment)

          self.multipleVehicleMatch = response.data.match
          self.showHeader = !(self.vehicle.VehicleDescription.length > 0)
        }
        self.boolLoading = false
      })
      .catch(error => {
        if (error.response.status == 403) { self.$router.push('/login') }
        // console.log(JSON.stringify(error))
        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
        self.dismissibleType = 'danger'
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      showHeader: true,
      boolLoading: false,
      txtLoading: 'Loading...',
      vehicle: null,
      equipment: null,
      typesList: [{ text: 'New', value: 1 }, { text: 'Used', value: 0 }],
      list_year_new: [],
      list_year_used: [],
      yearsList: [],
      makesList: [],
      modelsList: [],
      trimsList: [],
      deductions: [{
        key: 'Name', label: 'Deductions', thClass: 'h4 card-title table-borderless'
      }],
      multipleVehicleMatch: [],
      filterPredefined: null,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      predefinedEquipment: [],
      predefinedEquipmentFields: [
        { key: 'Factory', label: 'Factory Part', tdClass: 'w100', sortable: true },
        { key: 'Added', label: 'Installed By Default', tdClass: 'w100', sortable: true },
        { key: 'Name', label: 'Name', sortable: true },
        { key: 'Cost', label: 'Cost', tdClass: 'w100', sortable: true },
        { key: 'Price', label: 'Price', tdClass: 'w100', sortable: true }
      ],
      typeoptions: [
        { value: -1, text: 'All' },
        { value: 1, text: 'New' },
        { value: 0, text: 'Used' }
      ],
      dealerDefinedEquipment: [],
      dealerDefinedEquipmentFields: [
        // { key: 'NewUsedType', label: 'New / Used', tdClass: 'w100', sortable: true },
        { key: 'IsSuggested', label: 'Suggested', tdClass: 'w100', sortable: true },
        { key: 'IsSelected', label: 'Installed By Default', tdClass: 'w100', sortable: true },
        { key: 'Name', label: 'Name', sortable: true },
        { key: 'Cost', label: 'Cost', tdClass: 'w100', sortable: true },
        { key: 'Price', label: 'Price', tdClass: 'w100', sortable: true },
        { key: 'Tax', label: 'Tax', tdClass: 'w100', sortable: true }
      ],
      filter: null,
      currentPage2: 1,
      perPage2: 10,
      totalRows2: 0,
      editEquipment: false,
      dealerNew: null
    }
  },
  methods: {
    selectMultiVehicle (v) {
      this.multipleVehicleMatch = []

      this.vehicle.IsNew = v.isnew
      this.vehicle.MsCode = v.mscode
      this.vehicle.FullVehicleDescription = v.description
      this.vehicle.Make = v.make
      this.vehicle.Model = v.model
      this.vehicle.ShortDescription = v.short_desc
      this.vehicle.ModelNumber = v.modelnumber
      this.vehicle.Year = v.year
    },
    saveVehicle () {
      var self = this
      if (!self.vehicle) {
        self.errMsg = 'Data missing.'
        self.showDismissibleAlert = true
        self.dismissibleType = 'danger'
        return
      }
      self.vehicle.AddsDeducts.SerializableDealerDefEquipment = self.dealerDefinedEquipment.filter(x => x.IsSelected === true)
      self.vehicle.AddsDeducts.SerializableDealerInstalled = self.predefinedEquipment.filter(x => x.Added === true)

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.boolLoading = true
          axios.post('/api/inventory/createvehicle', self.vehicle)
            .then(response => {
              self.errMsg = 'Vehicle Saved'
              self.dismissibleType = 'success'
              self.showDismissibleAlert = true
              self.boolLoading = false
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    SetErrorMsg (error, action) {
      var self = this

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { self.$router.push('/login') }

      self.boolLoading = false

      self.errMsg = 'There was an error ' + action + ' your changes : '
      if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
        self.errMsg = self.errMsg + error.response.statusText
      } else {
        self.errMsg = self.errMsg + error
      }

      self.dismissibleType = 'danger'
      self.showDismissibleAlert = true

      if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { self.errMsg = error.response.statusText.replace('403.1', '') }
    },
    onFiltered (filteredItems) {
      this.totalRows2 = filteredItems.length
      this.currentPage2 = 1
    },
    taxExemptChanged (e) {
      e.TaxExempt = e.Tax
    },
    onPredefinedFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    addDealerEquipment () { },
    loadDealerData (data) {
      var d = data.map(x => {
        x['Tax'] = !x['TaxExempt']
        return x
      })
      this.dealerDefinedEquipment = d
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>
<style>
  .table > tbody > tr > td {
    vertical-align: middle;
  }

  .money {
    text-align: right;
    /*width:50px;*/
  }

  .input-group-text {
    background-color: transparent;
    border: none;
  }

  .table-borderless td,
  .table-borderless th {
    border: 0;
  }

  .table thead th {
    border-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/EditInventory.vue